import React, { useContext, useRef } from "react";
import { animated } from "react-spring";

import "./FileUploaderButton.css";

import { ReactComponent as UploadFile } from "../assets/icons/uploadFile.svg";
import { ReactComponent as Trash } from "../assets/icons/Trash.svg";
import { ReactComponent as Cross } from "../assets/icons/CrossM.svg";
import { NotificationContext } from "../Context/NotificationContext";
import { ReactComponent as DOWNLOAD } from "../assets/icons/Download.svg";
import GetFileTypeElement from "../Data/Functions/getFileType";

const FileUploaderButton = ({
  text,
  fontSize = 1.1,
  files,
  handleFiles,
  handleDeleteFile,
  display = false,
  backend = false,
  hideUploadBox = false,
  multiple = true,
  type,
  hideAddComment = false,
  textMaxWidth,
  showDownloadButton,
  hideDate,
  handleAddComment,
  showDeleteBtn 
}) => {
  const wrapperRef = useRef();
  const { showNotification } = useContext(NotificationContext);
  const fileInput = useRef();


  const checkFileSize = (e) => {
    const filesArray = Array.from(e.target.files);

    filesArray.forEach((file) => {
      if (file.size > 1000000 * 50){
        file.error = "File size it too lage. File must be less than 50 Mb.";    
        // showNotification(
        //   "Max File size.",
        //   `${file.name} exceeds 10 KB. Please upload smaller files.`,
        //   "error"
        // );
      } else {
        file.error = null;
      }
    });
    handleFiles(e);
  };

  const onDragEnter = () => wrapperRef.current.classList.add("dragover");
  const onDragLeave = () => wrapperRef.current.classList.remove("dragover");
  const onDrop = () => {
    wrapperRef.current.classList.remove("dragover");
    handleReset();
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    return `${splitted[1]} ${splitted[2]}, ${splitted[3]} ${hours}:${minutes
      .toString()
      .padStart(2, "0")} ${ampm}`;
  };

  

  const handleReset = () => {
    if (fileInput.current && !files.find((f) => f.status === "uploading")) {
      fileInput.current.value = "";
      fileInput.current.type = "text";
      fileInput.current.type = "file";
    }
  };

  const downloadFile = url => {
    window.open(url, '_blank')
}

  const handleDownloadFile = async (file) => {
    try {
      if (!file || !file.url) {
        showNotification("Error", "No file available for download.", "error");
        return;
      }
      downloadFile(file.url);
    } catch (error) {
      console.error("Download Error:", error);
      showNotification("Error", "Failed to download file.", "error");
    }
  };

  return (
    <div className="fileUploaderContainer">
      {!hideUploadBox && !showDownloadButton && !showDownloadButton && (
        <div
          className="dragDropBox"
          ref={wrapperRef}
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          style={{ marginBottom: display ? "1rem" : 0 }}
        >
          <UploadFile className="uploadFileIcon" />
        <div className="w-full flex flex-col gap-2">
          <p className="uploadFileTitle">
            <span>Select File</span> or drag and drop here
          </p>
          <p className="uploadFileText">Maximum file size is 50 MB.</p>
          <input
            type="file"
            name="file"
            title={" "}
            multiple={multiple}
            ref={fileInput}
            className="fileUploaderInput"
            id="file"
            onChange={(e) => e.target.value !== "" && checkFileSize(e)}
            onClick={handleReset}
            accept={
              type
                ? type
                : ".pdf, .doc, .docx, .xls, .xlsx, image/png, image/jpeg"
            }
          />
        </div>
        </div>
      )}

      {display
        ? files.map((file, index) => (
          <div key={index} className="fileUploaderLineOuter">
            <div className="fileUploaderLine">
              <div className="fileUploaderLineInfo">
                <GetFileTypeElement file={file}/>
                <p
                  className="fileUploaderLineName"
                  style={{ maxWidth: textMaxWidth ? textMaxWidth : "100%" }}
                >
                  {file.name}
                </p>
              </div>

              <div className="flex md:w-1/2 w-full md:gap-4 md:justify-end justify-around items-center">
                {file.status !== "uploading" &&
                  !hideDate &&
                  file.timestamp && (
                    <p className="fileUploaderLineSize max-sm:hidden">
                      {formatDate(file.timestamp)}
                    </p>
                  )}
                {/* {!hideAddComment && file.status !== "uploading" && (
                    <div
                      className="commentBtn"
                      onClick={() => handleAddComment(file)}
                    >
                      Add Comment
                    </div>
                  )} */}

                {file.status === "uploading" ? (
                  <div className="fileUploaderLineProgressContainer">
                    <animated.div
                      style={{
                        width: `${file.progress}%`,
                      }}
                      className="fileUploaderLineProgress"
                    />
                  </div>
                ) : null}

                {(file.status === "uploading" && !showDownloadButton) && (
                  <Cross
                    className="fileUploaderLineIcon"
                    onClick={() => handleDeleteFile(file)}
                  />
                )}
                {file.status !== "uploading" && !showDownloadButton && (
                  <Trash
                    className="fileUploaderLineIcon"
                    onClick={() => handleDeleteFile(file)}
                  />
                )}
                { showDeleteBtn && (
                  <Trash
                    className="fileUploaderLineIcon"
                    onClick={() => handleDeleteFile(file)}
                  />
                )}

                {showDownloadButton && (
                  <DOWNLOAD
                    className="hardCopyAddressIcon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDownloadFile(file)}
                  />
                )}

              </div>
            </div>
            {/* {file.timestamp && (
                <div className="fileUploaderLineProgressContainer">
                  <animated.div
                    style={{
                      width: `${file.progress}%`,
                      borderColor:
                        file.status === "complete" ? "#4CAF50" : "#FF7C1D",
                    }}
                    className="fileUploaderLineProgress"
                  />
                  <p className="fileUploaderLineProgressText">
                    {file.status === "complete"
                      ? "Completed"
                      : file.status === "failed"
                      ? "Upload Failed."
                      : file.status === "deleting"
                      ? "Deleting..."
                      : "Uploading (" + file.progress + "%)"}
                  </p>
                </div>
              )}
              {file.timestamp && (
                <p
                  className="fileUploaderFormattedTimestamp"
                  style={{ alignSelf: "flex-start" }}
                >{`Revision Source uploaded ${formatDate(file.timestamp)}`}</p>
              )} */}
          </div>
        ))
        : null}
    </div>
  );
};

export { FileUploaderButton };
